import { GeoBean, GeoControllerApi } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class GeoApi extends BaseApi {
    api: GeoControllerApi

    constructor() {
        super()
        this.api = new GeoControllerApi(configuration, configuration.basePath, this.fetch)
    }

    adGroupGeo(adGroupId: any): Promise<GeoBean[]> {
        return this.call(() => this.api.getAdGroupGeo(adGroupId))
    }

    campaignGeo(campaignId: any): Promise<GeoBean[]> {
        return this.call(() => this.api.getCampaignGeo(campaignId))
    }
}

const geoApi = new GeoApi()
export default geoApi


// WEBPACK FOOTER //
// ./src/component/app/geo/GeoApi.ts